// extracted by mini-css-extract-plugin
export default {"button":"button_button__xHc88","desktop":"button_desktop__Jx-Ut","mobile":"button_mobile__Z24tE","all":"button_all__SGY9B"};